import React from 'react';
import { withRouter } from 'react-router';
import { DI } from 'modules';
import Component from 'components/component';
import { Modal } from 'components/modal';
// import { Link } from 'react-router-dom'
import { myContent } from 'config/routes'

export class PaymentAlert extends Component {
    static defaultProps = {
        onClose: () => { },
    };

    onClose = (ev) => {
        this.props.actions.videos.setPaymentAlert(null);
        this.props.onClose(ev);
    }

    renderModal() {
        const alert = this.props.videos.paymentAlert;
        const { locale } = this.props.common;

        return (
            <Modal onClose={this.onClose}>
                <div className="popup-tip popup-tip--transcoding">
                    <span className="popup__title">{alert.title}</span>
                    {/* <span className="popup__loader" /> */}
                    <div className="popup__tip">{alert.text}</div>
                    <div className="popup-buttons">
                        <div className="popup-button">
                            <button onClick={() => this.props.history.push(myContent.getPath(locale))} type="button" className="text-button">Go to My Content</button>
                        </div>
                        <div className="popup-button">
                            <button onClick={this.onClose} type="button" className="button">Continue</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }

    render() {
        const alert = this.props.videos.paymentAlert;

        if (!alert) {
            return null;
        }

        if (alert.popup) {
            return this.renderModal();
        }

        return (
            <div className="live-payment-success">
                <div className="live-payment-success__title">{alert.title}</div>
                <div className="live-payment-success__text">{alert.text}</div>
            </div>
        );
    }
}

export default DI(['videos'])(withRouter(PaymentAlert));
